module.exports = __webpack_public_path__ + "static/programma-7e67f8d03c8dca25c3dda170c4d49b6a.png";